import { render, staticRenderFns } from "./OrdersCalendar.vue?vue&type=template&id=963e8ff0&"
import script from "./OrdersCalendar.vue?vue&type=script&lang=js&"
export * from "./OrdersCalendar.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports